import ListElementDraggaer from '@/Common/ListElementDragger'
import Utility from '@/Common/Utility'

function ChildDraggableBase() {

    this.listElementDraggaer = new ListElementDraggaer();
    this.LastMouseMoveDragHandleElement = null;
    this.LastMouseDownDragHandleElement = null;
    this.DragHandleMouseDown = false;
    this.DraggingState = "Ready";
    this.DropHandler = null;

    this.OnDragHandleMouseMove = function (e,targetList,dropHandler) {
        let containerElement = null;
        let containerSelector = null;
        let elementSelector = null;
        let dragHandleSelector = ".DragHandle";
        //let targetList = null;//Must be a array
        let canMoveX = true, canMoveY = true;
        let canDrag = true;

 
        if (e == null) {
            throw "argument 'e' is required !";
        }

        if (targetList == null) {
            throw "argument 'TargetList' is required !";
        }

        this.LastMouseMoveDragHandleElement = e.target;

        if (this.LastMouseMoveDragHandleElement.getAttribute("DragHandleSelector") != null) {
            dragHandleSelector = this.LastMouseMoveDragHandleElement.getAttribute("DragHandleSelector");
        }

        while (!this.LastMouseMoveDragHandleElement.matches(dragHandleSelector)) {

            if (this.LastMouseMoveDragHandleElement.getAttribute("DragHandleSelector") != null) {
                dragHandleSelector = this.LastMouseMoveDragHandleElement.getAttribute("DragHandleSelector");
            }
            else if (this.LastMouseMoveDragHandleElement.parentElement.getAttribute("DragHandleSelector") != null) {
                dragHandleSelector = this.LastMouseMoveDragHandleElement.parentElement.getAttribute("DragHandleSelector");
            }


            this.LastMouseMoveDragHandleElement = this.LastMouseMoveDragHandleElement.parentElement;

            if (this.LastMouseMoveDragHandleElement.tagName == "BODY") {
                break;
            }
        }
         

        if (this.LastMouseMoveDragHandleElement.tagName == "BODY") {
           
            if ((this.LastMouseMoveDragHandleElement = e.target.querySelector(dragHandleSelector)) != null) {
            }
            else {
                alert(e.target.outerHTML);
                throw "Can not find Element match selector '" + dragHandleSelector+"' !";
            }
        }

        this.DropHandler = null;


        this.LastMouseMoveDragHandleElement.addEventListener("selectstart", this.OnDragHandleSelectStart);

        if (this.LastMouseMoveDragHandleElement.getAttribute("HasBindMouseDownEvent") == null) {
            this.LastMouseMoveDragHandleElement.addEventListener("mousedown", this.OnDragHandleMouseDown);

            this.LastMouseMoveDragHandleElement.addEventListener("mouseup",
                this.OnDragHandleMouseUp);
        }



        //console.log("DraggingState = " + this.DraggingState);

        if (this.DragHandleMouseDown == true) {


            this.DropHandler = dropHandler;

            if (this.LastMouseMoveDragHandleElement == this.LastMouseDownDragHandleElement) {

                if (this.DraggingState == "Ready") {

                    //if (!this.LastMouseMoveDragHandleElement.classList.contains("DragHandle")) {
                    //    this.LastMouseMoveDragHandleElement.classList.add("DragHandle");
                    //}

                    //#region ContainerElement
                    containerSelector = this.LastMouseMoveDragHandleElement.getAttribute("ContainerSelector");

                    if (containerSelector == null) {
                        throw `ContainerSelector not set !`;
                    }
                    else {
                        let parentElement = null;

                        containerSelector = this.LastMouseMoveDragHandleElement.getAttribute("ContainerSelector");

                        parentElement = this.LastMouseMoveDragHandleElement;

                        while (true) {
                            if (parentElement.matches(containerSelector)) {
                                containerElement = parentElement;
                                break;
                            }
                            else {
                                parentElement = parentElement.parentElement;
                                if (parentElement.tagName == "BODY") {
                                    throw `Can not fine containerElement with selector '${containerSelector}' `;
                                }
                            }
                        }
                    }
                    //#endregion


                    //#region ElementSelector
                    elementSelector = this.LastMouseMoveDragHandleElement.getAttribute("ElementSelector");

                    if (elementSelector == null) {
                        throw `ElementSelector not set`;
                    }
                    //#endregion


                    //#region TargetList
                    
                    //#endregion

                    //#region CanDrag
                    if (this.LastMouseMoveDragHandleElement.getAttribute("CanDrag") != null) {
                        if (this.LastMouseMoveDragHandleElement.getAttribute("CanDrag").toLowerCase() == "false") {
                            canDrag = false;
                        }
                    }
                    //#endregion


                    //#region CanMoveX
                    if (this.LastMouseMoveDragHandleElement.getAttribute("CanMoveX") != null) {
                        if (this.LastMouseMoveDragHandleElement.getAttribute("CanMoveX").toLowerCase() == "false") {
                            canMoveX = false;
                        }
                    }
                    //#endregion


                    //#region CanMoveY
                    if (this.LastMouseMoveDragHandleElement.getAttribute("CanMoveY") != null) {
                        if (this.LastMouseMoveDragHandleElement.getAttribute("CanMoveY").toLowerCase() == "false") {
                            canMoveY = false;
                        }
                    }
                    //#endregion


                    console.log("Drag Start");


                    this.DraggingState = "Dragging";

                     
                    if (canDrag) {

                        this.listElementDraggaer.mouseDown = true;

                        this.listElementDraggaer.Attach(
                            {
                                ContainerElement: containerElement,
                                ToDragElementSelector: elementSelector,
                                TargetList: targetList,
                                DragHandleSelector: ".DragHandle",
                                DropHandler: this.OnDrop,
                                CanMoveX: canMoveX,
                                CanMoveY: canMoveY,
                                TargetListChangeHandler: () => {

                                    if (this.$forceUpdate != null) {
                                        this.$forceUpdate();
                                    }
                                }
                            }
                        );

                        this.listElementDraggaer.OnDragHandleDragStart(e);
                        this.listElementDraggaer.DraggingState = "Dragging";
                    }
                }
                else {
                    //console.log("Dragging");
                }
            }
        }

    }.bind(this);


    this.OnDrop = function (e) {

        if (this.DropHandler != null) {
            this.DropHandler(e);
        }

        this.listElementDraggaer.Detach();

        this.DragHandleMouseDown = false;
        this.DraggingState = "Ready";

        this.$forceUpdate();
    }.bind(this);

    this.OnDragHandleSelectStart = function (e) {
        e.preventDefault();
        return false;
    }.bind(this);

    this.OnDragHandleMouseDown = function (e) {
        let dragHandleSelector = ".DragHandle";
         
        this.DragHandleMouseDown = true;

        this.LastMouseDownDragHandleElement = e.target;

        if (this.LastMouseDownDragHandleElement.getAttribute("DragHandleSelector") != null) {
            dragHandleSelector = this.LastMouseDownDragHandleElement.getAttribute("DragHandleSelector");
        }

        while (!this.LastMouseDownDragHandleElement.matches(dragHandleSelector)) {
            if (this.LastMouseDownDragHandleElement.getAttribute("DragHandleSelector") != null) {
                dragHandleSelector = this.LastMouseDownDragHandleElement.getAttribute("DragHandleSelector");
            }
            else if (this.LastMouseDownDragHandleElement.parentElement.getAttribute("DragHandleSelector") != null) {
                dragHandleSelector = this.LastMouseDownDragHandleElement.parentElement.getAttribute("DragHandleSelector");
            }

            this.LastMouseDownDragHandleElement = this.LastMouseDownDragHandleElement.parentElement;

            if (this.LastMouseDownDragHandleElement.tagName == "BODY") {
                break;
            }
        }
         
    }.bind(this);


    this.OnDragHandleMouseUp = function (e) {
        this.DragHandleMouseDown = false;
          

        this.DraggingState = "Ready";

        if (this.LastMouseMoveDragHandleElement == null) {
            return;
        }

        this.LastMouseMoveDragHandleElement.removeEventListener("selectstart", this.OnDragHandleSelectStart);
        this.LastMouseMoveDragHandleElement.removeEventListener("mousedown", this.OnDragHandleMouseDown);
        this.LastMouseMoveDragHandleElement.removeEventListener("mouseup",
            this.OnDragHandleMouseUp);


        this.LastMouseDownDragHandleElement = null;
        this.LastMouseMoveDragHandleElement = null;
    }.bind(this);
}


export default ChildDraggableBase;
